/* eslint-disable class-methods-use-this */

class ChitChatsPrinterAppNav {
  constructor(printer, $container) {
    this.printer = printer;
    this.navigation = $container.find("#printer-nav");
    this.bindEvents($container);
  }

  bindEvents($container) {
    var self = this;

    $container.on("click", ".js-next-btn", function(e) {
      $container.find(".nav-link, .tab-pane").removeClass("active");
      self.setActiveTab($(e.target).data("tab"));
    });
  }

  setActiveTab(tab) {
    $(tab).addClass("active").removeClass("fade");
  }
}

export { ChitChatsPrinterAppNav };
